var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product"},[_c('img',{staticClass:"pic",attrs:{"src":_vm.$$viewImage(_vm.vorderDetail.commdtyImage)}}),_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.vorderDetail.spuName))])])}
var staticRenderFns = []

export { render, staticRenderFns }